import AppApi from '@app/api/index';

export interface ApiTokenDto {
  id: number;
  name: string;
  prefix: string;
  createdAt: string;
  revokedAt?: string | null;
}

export interface CreateApiTokenDto {
  name: string;
}

export interface CreateApiTokenResponse {
  token: string;
  id: number;
  name: string;
  prefix: string;
  createdAt: string;
}

export default class ApiTokensApi {
  constructor(private readonly api: AppApi) {}

  getList(): Promise<ApiTokenDto[]> {
    return this.api.client.get<ApiTokenDto[]>('/api-tokens').then((r: unknown) => r as ApiTokenDto[]);
  }

  create(dto: CreateApiTokenDto): Promise<CreateApiTokenResponse> {
    return this.api.client.post<CreateApiTokenDto, CreateApiTokenResponse>('/api-tokens', dto).then((r: unknown) => r as CreateApiTokenResponse);
  }

  revoke(id: number): Promise<void> {
    return this.api.client.patch<void>(`/api-tokens/${id}/revoke`).then(() => undefined);
  }

  delete(id: number): Promise<void> {
    return this.api.client.delete<void>(`/api-tokens/${id}`).then(() => undefined);
  }
}
